import { useMemo } from 'react';
import { SmartList } from 'shared/types/smart-list';
import { GroupByMode, TaskGroupBy } from 'shared/types/sorting-mode';
import { noGroupingId } from 'shared/views/task-filter-list';

export const useSmartListCustomOrderByGrouping = (
  groupBy: TaskGroupBy | undefined | null,
  smartList?: SmartList,
) =>
  useMemo(() => {
    if (!smartList?.id) {
      return {};
    }
    const _groupBy = (
      [GroupByMode.None, GroupByMode.LifeArea].includes(groupBy!)
        ? GroupByMode.Priority // Default to Priority if no grouping or Tag grouping (avoid recursion/nonsense)
        : groupBy ?? GroupByMode.Priority
    ) as Exclude<GroupByMode, GroupByMode.None | GroupByMode.LifeArea>;

    if (groupBy === GroupByMode.None) {
      return {
        [noGroupingId]: smartList.taskSorting ?? [],
      };
    }

    return smartList.customTaskOrder?.[_groupBy] ?? {};
  }, [
    smartList?.customTaskOrder,
    smartList?.id,
    smartList?.taskSorting,
    groupBy,
  ]);
